import React from 'react';
import { motion } from 'framer-motion';
import { Check, AlertCircle } from 'lucide-react';
export function ProductReveal() {
  return <section className="w-full bg-[#050505] py-24 px-4 relative overflow-hidden" data-id="element-295">
      {/* Background Gradient */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[#050505] via-[#0a0a0a] to-[#050505] pointer-events-none" data-id="element-296"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-297">
        {/* TRANSITION */}
        <div className="text-center mb-24 space-y-8" data-id="element-298">
          <h2 className="font-serif text-3xl md:text-4xl text-[#f5f0e8]" data-id="element-299">
            ¿Qué se hace? <br data-id="element-300" />
            <span className="text-[#d4af37]" data-id="element-301">
              Ser más mecánico donde eres más vulnerable.
            </span>
          </h2>

          <div className="flex flex-wrap justify-center gap-4 text-sm md:text-base text-[#8a8578] italic" data-id="element-302">
            <span className="border-b border-red-900/50 pb-1" data-id="element-303">
              "esta vez es diferente"
            </span>
            <span className="border-b border-red-900/50 pb-1" data-id="element-304">
              "solo un trade más"
            </span>
            <span className="border-b border-red-900/50 pb-1" data-id="element-305">
              "si recupero, cierro"
            </span>
          </div>

          <p className="text-2xl md:text-3xl font-serif text-[#d4af37] pt-8" data-id="element-306">
            Tu mente no necesita razón. <br data-id="element-307" />
            Solo necesita alivio.
          </p>
        </div>

        {/* PRODUCT SHOWCASE */}
        <div className="bg-[#080808] border border-[#222] rounded-2xl p-8 md:p-12 shadow-2xl shadow-black/50" data-id="element-308">
          <div className="text-center mb-12" data-id="element-309">
            <span className="text-[#8a8578] text-sm tracking-[0.2em] uppercase" data-id="element-310">
              Presentando
            </span>
            <h3 className="font-serif text-4xl md:text-6xl text-[#f5f0e8] mt-4 mb-2" data-id="element-311">
              TRADING EN <span className="text-[#d4af37]" data-id="element-312">PAZ</span>
            </h3>
            <p className="text-[#8a8578]" data-id="element-313">
              El sistema mental que te mantiene "plano"
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16" data-id="element-314">
            <div className="relative" data-id="element-315">
              <div className="absolute inset-0 bg-[#d4af37]/10 blur-[40px] rounded-full" data-id="element-316"></div>
              <img src="https://cdn.magicpatterns.com/uploads/hQPLBsfQFPrPVRzJP5VmAi/Imagen_final_del_producto.png" alt="Trading en Paz Product" className="relative z-10 w-full rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-500" data-id="element-317" />
            </div>

            <div className="space-y-8" data-id="element-318">
              <div className="space-y-2" data-id="element-319">
                <h4 className="text-xl font-serif text-[#f5f0e8] flex items-center gap-3" data-id="element-320">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#d4af37] text-black font-bold text-sm" data-id="element-321">
                    1
                  </span>
                  Protocolo Plano (PP-7)
                </h4>
                <p className="text-[#8a8578] pl-11 text-sm leading-relaxed" data-id="element-322">
                  Herramienta de intervención en tiempo real. Corta el sabotaje
                  antes de que crezca.
                </p>
              </div>

              <div className="space-y-2" data-id="element-323">
                <h4 className="text-xl font-serif text-[#f5f0e8] flex items-center gap-3" data-id="element-324">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#d4af37] text-black font-bold text-sm" data-id="element-325">
                    2
                  </span>
                  Reprogramación Identitaria (RI-3)
                </h4>
                <p className="text-[#8a8578] pl-11 text-sm leading-relaxed" data-id="element-326">
                  Sistema de identidad para que el sabotaje aparezca cada vez
                  menos.
                </p>
              </div>
            </div>
          </div>

          {/* DEEP DIVE: PP-7 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-327">
            <div className="bg-[#111] p-6 rounded-lg border border-[#333]" data-id="element-328">
              <div className="flex items-center gap-2 mb-4 text-[#d4af37]" data-id="element-329">
                <AlertCircle size={20} data-id="element-330" />
                <h4 className="font-bold tracking-wide text-sm" data-id="element-331">
                  PP-7: LOS GATILLOS
                </h4>
              </div>
              <p className="text-[#f5f0e8] text-sm mb-4" data-id="element-332">
                Si aparece este gatillo → aplico esta respuesta.
              </p>
              <ul className="space-y-2 text-sm text-[#8a8578]" data-id="element-333">
                <li className="flex justify-between border-b border-[#222] pb-2" data-id="element-334">
                  <span data-id="element-335">FOMO</span>
                  <span className="text-[#f5f0e8]" data-id="element-336">
                    Pausa 90s + regla "2 velas"
                  </span>
                </li>
                <li className="flex justify-between border-b border-[#222] pb-2" data-id="element-337">
                  <span data-id="element-338">Pérdida reciente</span>
                  <span className="text-[#f5f0e8]" data-id="element-339">
                    Cierre 3 min + respiración
                  </span>
                </li>
                <li className="flex justify-between border-b border-[#222] pb-2" data-id="element-340">
                  <span data-id="element-341">Euforia</span>
                  <span className="text-[#f5f0e8]" data-id="element-342">Reduzco tamaño al 70%</span>
                </li>
              </ul>
            </div>

            {/* DEEP DIVE: RI-3 */}
            <div className="bg-[#111] p-6 rounded-lg border border-[#333]" data-id="element-343">
              <div className="flex items-center gap-2 mb-4 text-[#d4af37]" data-id="element-344">
                <Check size={20} data-id="element-345" />
                <h4 className="font-bold tracking-wide text-sm" data-id="element-346">
                  RI-3: IDENTIDAD
                </h4>
              </div>
              <div className="space-y-4" data-id="element-347">
                <div data-id="element-348">
                  <p className="text-[#f5f0e8] text-sm font-medium" data-id="element-349">
                    A) Lenguaje
                  </p>
                  <p className="text-xs text-[#8a8578]" data-id="element-350">
                    "No reparo dolor con clicks."
                  </p>
                </div>
                <div data-id="element-351">
                  <p className="text-[#f5f0e8] text-sm font-medium" data-id="element-352">
                    B) Ritual
                  </p>
                  <p className="text-xs text-[#8a8578]" data-id="element-353">
                    Semáforo + Checklist (60 seg)
                  </p>
                </div>
                <div data-id="element-354">
                  <p className="text-[#f5f0e8] text-sm font-medium" data-id="element-355">
                    C) Evidencia
                  </p>
                  <p className="text-xs text-[#8a8578]" data-id="element-356">
                    Diario mínimo de obediencia
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center border-t border-[#222] pt-12" data-id="element-357">
            <p className="font-serif text-xl md:text-2xl text-[#f5f0e8] leading-relaxed" data-id="element-358">
              "Trading en paz no significa no sentir. <br data-id="element-359" />
              <span className="text-[#d4af37]" data-id="element-360">
                Significa no obedecerle al sentimiento.
              </span>
              "
            </p>
          </div>
        </div>
      </div>
    </section>;
}